export const DONOTCALLDATA = 'DONOTCALLDATA'
export const CONTACTDATA = 'CONTACTDATA'
export const FETCH = 'FETCH'
export const FETCH2 = 'FETCH2'
